module.exports = __webpack_public_path__ + "img/16.55b588ff.png";